@if (lines().length) {
  <div class="container">
    @for (line of lines(); track $index) {
      <div
        class="line"
        [style.paddingInlineStart.px]="line.depth * indent()"
      >
        <span class="key">{{ line.key }}</span>
        <span class="separator">:</span>
        <span class="value">{{ line.value }}</span>
      </div>
    }
  </div>
}
